export default [
  [
    `Размер`,
    `Длина рукава (см)`,
    `Высота по спинке (см)`,
    `Ширина под проймой, 2.5см под рукавом (см)`
  ],
  [`XS`, `12.9`, `61.4`, `37.5`],
  [`S`, `13.4`, `63.4`, `40`],
  [`M`, `13.9`, `65.4`, `42.5`],
  [`L`, `14.4`, `67.4`, `45.5`],
  [`XL`, `14.9`, `69.4`, `48.5`],
  [`2XL`, `15.4`, `71.4`, `51.5`]
];
